import { useQuery, useQueryClient } from '@tanstack/react-query';
import {
  getBQRoutinesSyncStatus,
  listArgumentsInRoutine,
  listBigQueryRoutines,
} from 'services/acg/phase-1';
import {
  showInfoNotification,
  showSuccessNotification,
} from '../../../services/common';
import { SOCKET_EVENTS, SOCKET_NAME, useSocket } from '../../../socket';
import { useEffect } from 'react';

export const useGetBQRoutinesSyncStatus = () => {
  return useQuery(
    ['getBQRoutinesSyncStatus'],
    () => getBQRoutinesSyncStatus(),
    {
      initialData: {
        isSyncing: false,
      },
    },
  );
};

export const useListBigQueryRoutines = () => {
  return useQuery(['listBigQueryRoutines'], () => listBigQueryRoutines(), {
    initialData: [],
  });
};

export const useListBigQueryRoutineArguments = (routineName: string) => {
  return useQuery(
    ['listBigQueryRoutineArguments', routineName],
    () => listArgumentsInRoutine(routineName),
    {
      initialData: [],
    },
  );
};

export const useBQRoutinesSyncStatusSubscription = () => {
  const queryClient = useQueryClient();
  function onSyncStatusChange(data: { isSyncing: boolean }) {
    queryClient.setQueryData(['getBQRoutinesSyncStatus'], () => {
      return data;
    });
    if (!data.isSyncing) {
      void queryClient.invalidateQueries(['listBigQueryRoutines']);
      showSuccessNotification('BigQuery routines synced successfully');
    } else {
      showInfoNotification('BigQuery routines syncing process started...');
    }
  }
  const socket = useSocket(SOCKET_NAME.ACG_PHASE_1);
  useEffect(() => {
    socket.on(
      SOCKET_EVENTS.ACG_PHASE_1.BQ_ROUTINES_SYNC_STATUS_UPDATED,
      onSyncStatusChange,
    );
    return () => {
      socket.off(
        SOCKET_EVENTS.ACG_PHASE_1.BQ_ROUTINES_SYNC_STATUS_UPDATED,
        onSyncStatusChange,
      );
    };
  }, [socket]);
};
